import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { normalize } from 'normalizr';
import { camelizeKeys } from 'humps';
import { authHeaders } from '../actions';
import { Schemas } from '../actions/schemas';

const fetchPlayerSurvey = async (surveyId, teacherId = null) => {
  const params = teacherId ? { teacher_id: teacherId } : {};
  const response = await axios.get(
    `/api/dashboard/asq_surveys/${surveyId}`,
    { headers: authHeaders(), params }
  );
  return normalize(camelizeKeys(response.data), Schemas['PLAYER_SURVEY']);
};

const fetchPlayer = async (playerId) => {
  const response = await axios.get(
    `/api/dashboard/players/${playerId}`,
    { headers: authHeaders() }
  );
  return camelizeKeys(response.data);
};

const fetchQuestionnaires = async (playerId) => {
  const response = await axios.get(
    `/api/dashboard/players_filters/${playerId}?all=true`,
    { headers: authHeaders() }
  );
  return camelizeKeys(response.data).questionnaires || [];
};

const fetchSurveyStatus = async (playerId, surveyId, jobId) => {
  const response = await axios.get(
    `/api/dashboard/players/${playerId}/player_questionnaires/${surveyId}/status?job_id=${jobId}`,
    { headers: authHeaders() }
  );
  return normalize(camelizeKeys(response.data), Schemas['SURVEY']);
};

export const usePlayer = (playerId) => useQuery({
  queryKey: ['player', playerId],
  queryFn: () => fetchPlayer(playerId),
  enabled: !!playerId,
});

export const usePlayerSurvey = (surveyId, teacherId = null) => useQuery({
  queryKey: ['playerSurvey', surveyId, teacherId],
  queryFn: () => fetchPlayerSurvey(surveyId, teacherId),
  enabled: !!surveyId,
  placeholderData: (previousData) => previousData,
});

export const usePlayerQuestionnaires = (playerId) => useQuery({
  queryKey: ['playerQuestionnaires', playerId],
  queryFn: () => fetchQuestionnaires(playerId),
  enabled: !!playerId,
});

export const useTeacherGradingStatus = (playerId, teacherSurvey) => {
  const isGrading = teacherSurvey
    ? teacherSurvey.status === 'finished' && !teacherSurvey.asqId && !!teacherSurvey.asqJid
    : false;

  return useQuery({
    queryKey: ['teacherGradingStatus', teacherSurvey?.id, teacherSurvey?.asqJid],
    queryFn: () => fetchSurveyStatus(playerId, teacherSurvey.id, teacherSurvey.asqJid),
    enabled: isGrading,
    refetchInterval: isGrading ? 3500 : false,
  });
};
